import React from 'react';

export default function TagChip({ tag, onRemove }) {
  return (
    <span style={{
      display: 'inline-flex', alignItems: 'center', gap: 4,
      background: '#e9ecef', borderRadius: 4, padding: '2px 8px', fontSize: 11
    }}>
      {tag}
      {onRemove && (
        <button onClick={onRemove} style={{ background: 'none', border: 'none', color: '#dc3545', cursor: 'pointer', fontSize: 12, marginLeft: 2 }}>×</button>
      )}
    </span>
  );
}
